import BaseClass from "../BaseClass.js";

export default class MediaCenter extends BaseClass {

    constructor(element) {
        super(element);
        this.$toggleClass = null;
        this.$checkedContainer = null;
        this.$checkBoxCounter = null;
        this.$checkBoxFilter = null;
        this.$radioCheckBoxFilter = null;
        this.$filterButtons = null;
        this.$toggleAllCheckboxes = null;
        this.$toggleButtonVisibility = null;
        this.$resetAllFilterId = null;
        this.$searchBar = null;
        this.$adjustableButtons = null;
        this.$checkboxListener = null;
        this.checkBoxCounter = 0;
        this.cachedUploadIDs = [];
        this.autoloading = false;
        this.galleryInitialized = false;
        this.init();
    }

    init() {

        let $checkedContainer = this.$element.find('[data-type="checked-container"]');
        if ($checkedContainer != undefined) {
            this.$checkedContainer = $checkedContainer;
        }

        let $checkBoxCounter = this.$element.find('[data-type="checkbox-counter"]');
        if ($checkBoxCounter != undefined) {
            this.$checkBoxCounter = $checkBoxCounter;
        }

        let $checkBoxFilter = this.$element.find('[data-type="checkbox-filter"]');
        if ($checkBoxFilter != undefined) {
            this.$checkBoxFilter = $checkBoxFilter;
        }

        let $radioCheckBoxFilter = this.$element.find('[data-type="checkbox-filter"]input[type="radio"]');
        if ($radioCheckBoxFilter != undefined) {
            this.$radioCheckBoxFilter = $radioCheckBoxFilter;
        }

        let $filterButtons = this.$element.find('[data-type="sort-icon"]');
        if ($filterButtons != undefined) {
            this.$filterButtons = $filterButtons;
            this.$filterButtons.each(function () {
                this.setAttribute('baseClass', $(this).attr("class"));
            });
        }

        let $toggleAllCheckboxes = this.$element.find('[data-type="toggle-all-checkboxes"]');
        if ($toggleAllCheckboxes != undefined) {
            this.$toggleAllCheckboxes = $toggleAllCheckboxes;
        }

        let $toggleButtonVisibility = this.$element.find('[data-type="toggle-button-visibility"]');
        if ($toggleButtonVisibility != undefined) {
            this.$toggleButtonVisibility = $toggleButtonVisibility;
        }

        let $resetAllFilterId = this.$element.find('[data-type="reset-all-filter"]');
        if ($resetAllFilterId != undefined) {
            this.$resetAllFilterId = $resetAllFilterId;
        }

        let $searchBar = this.$element.find('[data-type="search-bar"]');
        if ($searchBar != undefined) {
            this.$searchBar = $searchBar;
        }

        let $adjustableButtons = this.$element.find('[data-type="adjustable-button"]').children();
        if ($adjustableButtons != undefined) {
            this.$adjustableButtons = $adjustableButtons;
        }

        let mySelf = this;
        $(document).on('content:loaded', function (event, data) {
            // behebt einen bug wo beim erneuten Öffnen eines Galerie Modals $element nicht definiert ist
            if (mySelf.$element != undefined) {
                let $toggleClass = mySelf.$element.find('[data-type="toggle-checkbox"]');
                if ($toggleClass != undefined) {
                    mySelf.$toggleClass = $toggleClass;
                }

                let $checkboxListener = mySelf.$element.find('[data-type="checkbox-listener"]');
                if ($checkboxListener != undefined) {
                    mySelf.$checkboxListener = $checkboxListener;
                }

                mySelf.onContentLoaded(event, data);
            }
        });

        this.initCheckBoxListener();
        this.initResetCounterFilter();
        this.initResetAllFilter();
        this.initCheckBoxFilterListener();
        this.toggleAllCheckboxesOnClick();
        this.resetCheckboxCounter();
    }

    initCheckBoxListener() {
        let mySelf = this;
        $(document).on('reset:mediaCenter:counter', function () {
            mySelf.resetCheckboxCounter();
        });
    }


    initCheckBoxes() {
        this.checkBoxCounter = parseInt($(this.$checkedContainer).text());
        let mySelf = this;

        this.$toggleClass.on("change", function () {
            if ($(this).prop('checked')) {
                mySelf.checkBoxCounter = mySelf.checkBoxCounter + 1;
                mySelf.addIdToCounter($(this).attr("id"));
                mySelf.$element.find('#card_' + $(this).attr("id")).addClass('border-accent-green');
            } else {
                mySelf.checkBoxCounter = mySelf.checkBoxCounter - 1;
                mySelf.removeIdFromCounter($(this).attr("id"));
                mySelf.$element.find('#card_' + $(this).attr("id")).removeClass('border-accent-green');
            }

            mySelf.updateButtons();
            mySelf.updateToggleCounter();
        });
    }

    initResetCounterFilter() {
        let mySelf = this;
        $(this.$checkBoxCounter).on("click", this.$checkBoxFilter, function () {
            mySelf.resetCheckboxCounter();
        });
    }

    initResetAllFilter() {
        let mySelf = this;

        this.$resetAllFilterId.on("click", function () {
            mySelf.autoloading = true;

            // suchleiste leeren
            mySelf.$searchBar.val("");

            //upload checkboxen abwählen
            mySelf.$toggleClass.prop('checked', false);

            // counter zurücksetzen
            mySelf.resetCheckboxCounter();

            // filter abwählen
            mySelf.$checkBoxFilter.prop('checked', false);

            // input field zurücksetzen
            mySelf.$checkBoxFilter.filter('#filter-one').click();

            // geht jedes FilterButton durch und ersetzt das derzeitige icon mit dem default icon
            mySelf.$filterButtons.each(function () {
                let currentFilterButton = $(this);
                currentFilterButton.removeAttr('class')
                let baseClass = currentFilterButton.attr('baseClass')
                currentFilterButton.addClass(baseClass);
            });

            mySelf.autoloading = false;
        });
    }

    toggleAllCheckboxesOnClick() {
        let mySelf = this;

        $(this.$toggleAllCheckboxes).on('click', function () {
            if (mySelf.autoloading) {
                return;
            }

            if ($(this).attr('data-select-all') === '1') {
                let $toggledClass = mySelf.$toggleClass;
                $toggledClass.prop('checked', true).trigger("change");
            } else {
                let $toggledClass = mySelf.$toggleClass;
                $toggledClass.prop('checked', false).trigger("change");
                mySelf.cachedUploadIDs = [];
            }
            mySelf.updateToggleCounter();
        });
    }

    updateToggleCounter() {
        this.checkBoxCounter = this.cachedUploadIDs.length;

        if (this.checkBoxCounter > 0) {
            $(this.$checkBoxCounter).removeClass("hidden");
            $(this.$toggleButtonVisibility).removeAttr('disabled', 'disabled');
        } else {
            $(this.$checkBoxCounter).addClass("hidden");
            $(this.$toggleButtonVisibility).attr('disabled', 'disabled');
        }

        $(this.$checkedContainer).html(this.checkBoxCounter);
    }

    resetToggleCounter() {
        this.autoloading = true;
        $(this.$checkBoxCounter).addClass("hidden");
        $(this.$toggleButtonVisibility).attr('disabled', 'disabled');
        this.cachedUploadIDs = [];
        $(this.$checkedContainer).html(0);
        this.autoloading = false;
    }

    addIdToCounter(elementId) {
        let cachedUploadIds = this.cachedUploadIDs;

        let isDuplicate = cachedUploadIds.includes(elementId);
        if (!isDuplicate) {
            this.cachedUploadIDs = cachedUploadIds.concat(elementId);
        }
    }

    removeIdFromCounter(elementId) {

        let cachedUploadIds = this.cachedUploadIDs;
        let isRemovable = false;
        if (cachedUploadIds) {
            isRemovable = cachedUploadIds.includes(elementId);
            if (isRemovable) {
                this.cachedUploadIDs = cachedUploadIds.filter(item => item !== elementId);
            }
        }
    }

    resetCheckboxCounter() {
        this.cachedUploadIDs = [];
        this.updateToggleCounter();
    }

    updateButtons() {
        let mySelf = this;
        this.$adjustableButtons.each(function () {
            let $element = $(this);
            let additionalDataAttribute = 'data-post-data';
            if ($element.attr('data-type') === 'modalhandler') {
                additionalDataAttribute = 'data-modaldata';
            }
            $element.removeAttr(additionalDataAttribute)
            const postData = new URLSearchParams($element.serialize())

            let additionalParameter = $element.data('additional-json');

            if (additionalParameter) {
                for (const key in additionalParameter) {
                    postData.append(key, additionalParameter[key]);
                }
            }

            mySelf.cachedUploadIDs.forEach(function (elementID) {
                postData.append('element_id[]', elementID);
            })

            $element.attr(additionalDataAttribute, postData.toString())
        });
    }

    onContentLoaded() {
        this.initCheckBoxes();

        let initializedUploadIds = this.$element.find("input[name=initialized-uploads]").map(function () {
            return this.value;
        }).get();

        if (initializedUploadIds.length !== 0 && this.galleryInitialized === false) {
            this.galleryInitialized = true;
            this.cachedUploadIDs = initializedUploadIds;
            this.updateToggleCounter();
        }

        let mySelf = this;
        this.$toggleClass.each(function () {
            if ($.inArray($(this).attr('id'), mySelf.cachedUploadIDs) !== -1) {
                $(this).prop('checked', true).trigger("change");
            }
        });

        $(this.$checkboxListener).on("click", function (e) {
            e.stopImmediatePropagation();
            mySelf.$element.find('#' + this.id + ' input').click();
        });
    }

    initCheckBoxFilterListener() {
        $(this.$radioCheckBoxFilter).on("click", function () {
            let dataIcon = $(this).attr("data-icon")
            let filterButton = $(this).closest('.media-center--categories-btn').find('[data-type="sort-icon"]');

            filterButton.removeAttr('class')
            filterButton.addClass(dataIcon);
        });
    }
}
